export const formatarData = (
  valor?: string | null,
  options?: Intl.DateTimeFormatOptions
): string | undefined => {
  if (!valor) return undefined;
  const data = new Date(valor);
  if (Number.isNaN(data.getTime())) return undefined;
  return data.toLocaleDateString('pt-BR', options ?? {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  });
};

export const formatarDataHora = (valor?: string | null): string | undefined => {
  if (!valor) return undefined;
  const data = new Date(valor);
  if (Number.isNaN(data.getTime())) return undefined;
  return data.toLocaleString('pt-BR');
};
